module.exports = __webpack_public_path__ + "static/media/no-alarm.f23d0cb4.png";